module.exports = __webpack_public_path__ + "img/xmasParty19.b856996a.jpg";